import React, { useEffect, useState } from 'react'
import bgimage from '../../Assets/bg1.jpg';
import './productstyle.css';
import api from '../../axiosInstance';

function ProviderAssignProduct() {
    const [distributerProducts, setDistributerProducts] = useState([]);

    const userid = sessionStorage.getItem('userid');

    const fetchDistributerProduct = async () => {
        if (!userid) return;
        try {
            const response = await api.get(`/userproduct?DISID=${userid}`);
            if (response.status === 200 && response.data?.data) {
                const data = response.data.data;

                // Ensure latestpricelist exists and format data properly
                const latestPriceListWithProductName = data.map(item => ({
                    ...(item.latestpricelist || {}), // Ensure latestpricelist exists
                    product_name: item.product_name || "Unknown Product",
                }));

                setDistributerProducts(latestPriceListWithProductName);
            }
        } catch (err) {
            console.error('Error fetching distributor products:', err);
        }
    };



    useEffect(() => {
        fetchDistributerProduct()
    }, [])


    console.log("fetchDistributerProduct",distributerProducts);
    return (
        <div className='container'>
            <h1 className='productfont'>Product</h1>
            <div className='row'>
                {distributerProducts?.map((items) => (
                    <div className='col-md-4 col-12 d-flex justify-content-center'>
                        <div className='col-10 rounded-4 border border-2 overflow-hidden'>
                            <div>
                                <img src={bgimage} className="card-img-top " alt="vvvv" height={150} />
                            </div>
                            <div>
                                <div className="m-2">
                                    <h5 className="m-0 productfont">{items?.product_name}</h5>
                                    {/* <p className="m-0">mmmmm</p> */}
                                    <p className="m-0">
                                        <strong className='productfont'>Date:</strong> {items?.effected_from}
                                    </p>
                                    <p className="m-0">
                                        <strong className='productfont'>Price:</strong> ₹{items?.price}
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                ))}


            </div>

        </div>
    )
}

export default ProviderAssignProduct